import { render, staticRenderFns } from "./KanbanConfigViewV3.vue?vue&type=template&id=52b30263&scoped=true&"
import script from "./KanbanConfigViewV3.vue?vue&type=script&lang=js&"
export * from "./KanbanConfigViewV3.vue?vue&type=script&lang=js&"
import style0 from "./KanbanConfigViewV3.vue?vue&type=style&index=0&id=52b30263&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b30263",
  null
  
)

export default component.exports